import React from 'react';
import { useTranslation } from 'react-i18next';
import { OperationType } from 'api';
import StatusBullet from 'components/StatusBullet/StatusBullet';
import dateTimeFormatter, { getTime } from 'utils/date/dateTimeFormatter';
import useStyles from './PassingListStyles';
const OBE_SIGNAL_CODES = ['02', '08', '40']; // based on chapter 1 of this document: https://www.autopass.no/_attachment/2902528/binary/1359128

import { showCheckboxColumn, passingsToExport } from 'api/passings/getFilteredPassings';
import { useRecoilState } from 'recoil';
import Checkbox from "@material-ui/core/esm/Checkbox";
export default function PassingList({
  id,
  totalPrice,
  transactedOn,
  licensePlateDetected,
  exitTollStationName,
  entryTollStationName,
  currency,
  signalCode,
  sender,
  operationType
}) {
  const {
    t
  } = useTranslation();
  const {
    passings,
    column
  } = useStyles();
  const formattedDate = dateTimeFormatter(transactedOn);
  const time = getTime(transactedOn);
  const chargedByObeRead = OBE_SIGNAL_CODES.includes(signalCode ?? '');
  const bulletColor = chargedByObeRead ? 'green' : 'yellow';
  const bulletText = chargedByObeRead ? t('passings.captured_by_obe') : t('passings.captured_by_image');
  const isDebit = operationType === OperationType.Debit;
  const [showCheckbox, setShowCheckbox] = useRecoilState(showCheckboxColumn);
  const [passingsToExportLst, setPassingsToExport] = useRecoilState(passingsToExport);
  const addOrRemoveExportFromList = (id, checked) => {
    if (checked) {
      if (!(passingsToExportLst.indexOf(id) > -1)) {
        setPassingsToExport(prevList => [...prevList, id]);
      }
    } else {
      setPassingsToExport(prevList => prevList.filter(listItem => listItem !== id));
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    key: id,
    className: passings
  }, showCheckbox && /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox, {
    value: id,
    color: "primary",
    checked: passingsToExportLst.indexOf(id) > -1 ? true : false,
    onChange: event => addOrRemoveExportFromList(event.target.value, event.target.checked)
  }))), /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement("div", null, licensePlateDetected), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StatusBullet, {
    status: bulletColor,
    text: bulletText
  }))), /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement("div", null, formattedDate), /*#__PURE__*/React.createElement("div", null, time)), /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement("div", null, sender), /*#__PURE__*/React.createElement("div", null, exitTollStationName || entryTollStationName)), /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement("div", null, `${isDebit ? '-' : ''}${totalPrice}`), /*#__PURE__*/React.createElement("div", null, currency)));
}